import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  position: 'relative',
  paddingBottom: '200',
  borderBottom: '1px solid {colors.border.subtle}',
  md: {
    marginInline: '0',
    padding: '0',
    border: 'none',
    minWidth: '320px',
  },
});

export const chevronContainerStyles = css.raw({
  position: 'absolute',
  top: '0px',
  right: '8px',
  padding: '{spacing.200} {spacing.400}',
});
